module.exports = __webpack_public_path__ + "static/media/kp-thoughtcast-logo.83cb7ff5.svg";